import { render, staticRenderFns } from "./preview-box.vue?vue&type=template&id=a938d218&scoped=true&"
import script from "./preview-box.vue?vue&type=script&lang=js&"
export * from "./preview-box.vue?vue&type=script&lang=js&"
import style0 from "./preview-box.vue?vue&type=style&index=0&id=a938d218&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a938d218",
  null
  
)

export default component.exports